import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CentaurCard from '../../CentaurCard';
import NewCollectionConfirmationPopup from '../NewCollectionConfirmationPopup';
import collectionCardStyles from '../CollectionCard/CollectionCard.scss';
var NewFolderCard = function (_a) {
    var isSaving = _a.isSaving, folderNameBlacklist = _a.folderNameBlacklist, deviationId = _a.collectibleDeviation.deviationId, createCollection = _a.createCollection;
    var _b = useState(false), showPrompt = _b[0], setShowPrompt = _b[1];
    var t = useTranslation().t;
    var onPromptDone = function (name) {
        setShowPrompt(false);
        if (!isSaving && name) {
            createCollection(name, deviationId);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: collectionCardStyles['card'], onClick: isSaving ? undefined : function () { return setShowPrompt(true); } },
            React.createElement(CentaurCard, { mode: isSaving ? 'progress' : 'add', title: t('collectionPanel.card.add') })),
        React.createElement(NewCollectionConfirmationPopup, { isOpen: showPrompt, folderNameBlacklist: folderNameBlacklist, onDone: onPromptDone, onCancel: function () { return setShowPrompt(false); } })));
};
export default NewFolderCard;
//# sourceMappingURL=NewFolderCard.js.map